import React from 'react'
import classNames from 'classnames'

import DisplayIcon from '@toasttab/shared/src/components/atoms/DisplayIcon/DisplayIcon'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const ProductHighlights = ({ body }: { body: any }) => {
  return (
    <section className='mb-10 lg:mb-16'>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid'>
          <div className='col-span-4 lg:col-span-12'>
            <div className='flex flex-col items-center lg:items-stretch lg:flex-row'>
              {body.highlights.map((highlight: any, i: number) => {
                const highlightClass = classNames(
                  'text-center group/highlight relative bg-white lg:rounded-base lg:px-6 !max-w-[279px] !max-h-[128px]',
                  {
                    'lg:!mb-0': i + 1 === body.highlights.length
                  }
                )
                const keyId = btoa(`${highlight.heading}-${i}`)
                return (
                  <div
                    key={`ph-${keyId}`}
                    className='mb-4 lg:mb-0 !max-w-[264px] !border-box'
                  >
                    <div className={highlightClass}>
                      <DisplayIcon
                        iconName={highlight.icon}
                        classes='mb-2 mx-auto w-10 h-10'
                      />
                      <Typography
                        as='h5'
                        variation='h5'
                        classes='!text-gray-125'
                        allowHtml={false}
                      >
                        {highlight.heading}
                      </Typography>
                      <Typography
                        as='p'
                        variation='default'
                        classes='text-secondary'
                        allowHtml={false}
                      >
                        {highlight.description}
                      </Typography>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductHighlights
